export default "__VITE_ASSET__XY7ti$eu__"